/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientNotifications/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientNotifications({
  children,
  viewPath = "/App/Account/PatientNotifications"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalAcknowledgedNotificationsByPatientValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'acknowledged_notifications_by_patient',
})
let globalPatientNotificationsPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'patient_notifications_patient_id',
})
let aggregateData = fromHelpers.getView(globalAcknowledgedNotificationsByPatientValueData, globalPatientNotificationsPatientIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}